export interface ICTPricingConfig {
  clusters: ICTPricingConfigCluster[];
}

export const ICT_PRICING_CONFIG_KEY = 'ICTPricing';
export const ICT_PRICING_CONFIG_PHONES = 'ictPricingPhones';
export const ICT_PRICING_IMAGE_PATH = 'assets/images/ICTPricing/';
export const ICT_PRICING_ROUTING_PATH = '/client-area/ict-pricing';

export interface ICTPricingConfigCluster {
  id: string;
  name: string;
  pricing: ClusterPricing[];
}

export interface ClusterPricing {
  ict: boolean;
  id: string;
  mobile: 'A' | 'B' | 'W';
  name: ClusterPricingNameType;
  text: string;
  type: 'image' | 'icon';
  imgName: string;
  url: string;
  src: string;
  origin?: string;
  callMeActivated?: boolean;
}

export type ClusterPricingNameType =
  'car' |
  'motorcycle' |
  'home' |
  'health' |
  'travels' |
  'dental' |
  'pets' |
  'life' |
  'deaths' |
  'deaths_foreign_residents' |
  'accidents' |
  'accidents_free_time' |
  'pension_plans' |
  'legal_defense' |
  'bikes' |
  'compensation' |
  'essential_compensation' |
  'communities' |
  'trust_life';

export interface ICTPricingUrlHttpResponse {
  resultCode: string;
  ictId: string;
  resultMessage: string;
  resultUrl: string;
}

export enum ICTPricingID {
  DEATHS = '7',
  DEATHS_FOREIGN_RESIDENTS = '8',
  LEGAL_DEFENSE = '9',
  BIKES = '10',
  PETS = '11',
  DENTAL = '15',
  ACCIDENTS = '16',
  ACCIDENTS_FREE_TIME = '38',
  HOME = '17',
  HEALTH = '18',
  LIFE = '19',
  PENSION_PLANS = '21',
  CAR = '23',
  MOTORCYCLE = '24',
  TRUST_LIFE = '37'
}

export enum ICTPricingHttpRequestData {
  SPINNER_ID = 'ict-pricing-url',
  URL_PATH = '/clients/pricing/ict',
  PAYLOAD_ORIGIN_APP = 'APP',
  PAYLOAD_ORIGIN_WEB = 'OIM',
  ENTITY_CODE = '00',
  GROUPING_CODE = '0',
  OPERATION_CODE_PREFIX = '8',
}

export enum ICTPricingROProductId {
  car = 'Autos',
  motorcycle = 'Motos',
  home = 'Hogar',
  health = 'Salud',
  dental = 'Dental',
  life = 'Vida',
  deaths = 'Decesos',
  deaths_foreign_residents = 'Decesos/Residentes extranjeros',
  accidents = 'FlexiAccidentes Modular',
  accidents_free_time = ' Accidentes Free Time',
  pension_plans = 'Pensión',
  legal_defense = 'LEX',
  bikes = 'Bicimas',
  pets = 'Mascotas',
  trust_life = 'Confianza Vida'
}

export interface CallMeRequestData {
  name?: string;
  phone: string;
  category: CallMeCategories;
}

export enum CallMeCategories {
  CAR = 'Coche',
  MOTORCYCLE = 'Moto',
  HOME = 'Hogar',
  HEALTH = 'Salud'
}

export enum CallMeHttpRequestData {
  URL_PATH = '/clients/pricing/callMeNow'
}

export interface CallMeHttpResponse {
  result: string;
  leadId: string;
  isNew: string;
}
